goog.provide('el8.data.model.copayPayment');

goog.require('el8.model.base');

// NOTE: In the backend, copayPayment maps to PatientPayment

(function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);

    _class.addDecimalProperty('amount', true);
    _class.addIntProperty('createUserId');
    _class.addDateTime('whenCollected');
    
    _class.prototype.asSoyMap = function() {
        var m = this.parent.asSoyMap.call(this);

        var createUser = el8.data.practiceUsers.getById(this.getCreateUserId());
        m['createUserName'] = (createUser) ? createUser.getFullName() : '';

        return m;
    };

    // check if a user-entered amount is equivalent to the amount
    // already stored in this model
    _class.prototype.isAmountEquivalent = function(testAmount) {
        var cleanedAmount = el8.util.string.cleanDecimal(testAmount);
        return (this.getAmount() === cleanedAmount ||
                this.getAmountFloat() === parseFloat(cleanedAmount));
    };

    el8.data.model.copayPayment = function(spec) { return new _class(spec); };

})();


